import { AxiosRequestConfig } from 'axios';
import { Cache } from '@aws-amplify/cache';
import { getIdTokenJwt } from '../interface/generic-form/IAuthSession';

export const AuthenticationInterceptor = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  try {
    const jwt = Cache.getItem("jwt");

    if (jwt && jwt.token) {
      const now = new Date();
      if (now < new Date(jwt.expiration * 1000)) {
        config.headers.Authorization = `Bearer ${jwt.token}`;
        return config;
      }
    }

    const { idToken, expiration } = await getIdTokenJwt();

    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
      Cache.setItem("jwt", {
        token: idToken,
        expiration: expiration
      });
    }
  } catch (error) {
    console.error(error);
  }

  return config;
};
